<template>
  <hypto-popup :title="'Initiate Refund'">
    <template #body>
      <p>Are you sure you want to initiate refund for UPI Collection <u @click="openTxns">{{details.order_id}}</u>?</p>
    </template>

    <template #footer>
      <button class="primary-btn" @click="initiateRefund">
        Confirm
      </button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/upiCollections'
import { openPopup } from '@/utils/helpers'

export default {
  name: 'UpiCollectRefundConfirmation',
  components: { HyptoPopup },
  props: {
    details: Object
  },
  methods: {
    openPopup,
    openTxns () {
      this.openPopup('CollectionDetails')
    },
    initiateRefund () {
      ApiServices.createRefund(this.details.id).then(response => {
        if (response.success) {
          this.successToastMsg(response.message)
          this.$emit('refreshList', response.data)
        } else {
          this.errorToastMsg(response.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

 u {
   color: $primary !important;
   cursor: pointer;
   font-weight: 500;
 }
</style>
